export const calendarType = {
    hebrew: "hebrew",
    jewish: "jewish"
}